<template>
  <div :class="['my_edit_item', 'my_input_number_wrapper', inline ? 'edit_item_inline' : 'edit_item_block']">
    <div class="input-wrapper" :style="{ width: inputWidth + 'px' }">
      <el-input-number
        v-model="result"
        ref="myInputIntNumber"
        class="my_input_number"
        :size="size"
        :min="min"
        :max="max"
        :step="step"
        :placeholder="placeholder"
        controls-position="right"
        :stepStrictly="stepStrictly"
        @input.native="input_number"
        @change="change_number"
        @keyup.enter.native="change_number"
        :disabled="disabled"
        :precision="precision"
        :style="{width:inputWidth+'px'}">
      </el-input-number>
      <i v-if="symbol" class="my-num-symbol" slot="suffix">{{ symbol }}</i>
    </div>
    <span class="my_title" :style="{ width: titleWidth + 'px' }">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'MyInputNumberIndex',
  data() {
    return {
      number: this.value,
      numberTemp: this.value,
      result: this.value,
      inputWidth: 95
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
    size: {
      type: String,
      default: 'medium'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    precision: {
      type: Number || undefined,
      default: undefined
    },
    stepStrictly: {
      type: Boolean,
      default: false
    },
    titleWidth: {
      type: [Number, String],
      default: 'auto'
    },
    width: {
      type: [Number, String],
      default: 95
    },
    inline: {
      type: Boolean,
      default: true
    },
    symbol: {
      type: String,
      default: ''
    },
    isInt: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    value(val) {
      this.number = this.value
      this.numberTemp = this.value
      this.result = this.value
    },
    result(val) {
      if (val !== Infinity) {
        this.$emit('update:value', val)
        this.$emit('change', val)
      }
    }
  },
  methods: {
    input_number(event) {
      // debugger
      const number = event.target.value
      if (number === '') {
        this.numberTemp = this.min
        return
      }
      if (String(event.target.value).endsWith('.')) {
        this.number = number
        this.numberTemp = number
        if (this.isInt) {
          this.result = number
        }
        return
      }
      if (this.isLegalNumber(number)) {
        this.number = number
        this.numberTemp = number
        if (number > this.max) {
          this.number = this.max
          this.numberTemp = this.max
        }
      } else {
        this.number = this.numberTemp
      }

      this.result = Number(this.number)
      this.$emit('change', this.number)
    },
    change_number(number) {
      if (number === '') {
        this.number = this.min
        this.numberTemp = this.min
        this.result = this.min
      }
      this.$emit('change', this.number)
    },
    isLegalNumber(num) {
      if (this.step === 1) {
        return this.is_int(num)
      } else {
        return this.is_number(num)
      }
    },
    is_int(number) {
      // 0和第一位不为0的正整数
      const reg = /^(0|[1-9]\d*)$/
      return reg.test(number)
    },
    is_number(num) {
      return !isNaN(num)
    },
    checkAndUpdateBeforeDestroy() {
      if (this.result === this.numberTemp) {
        return
      }
      const number = this.numberTemp
      if (number === '') {
        this.numberTemp = this.min
        return
      }
      if (this.isLegalNumber(number)) {
        this.number = number
        this.numberTemp = number
        if (number > this.max) {
          this.number = this.max
          this.numberTemp = this.max
        }
      } else {
        this.number = this.numberTemp
      }
      this.result = Number(this.number)
      this.$emit('change', this.number)
    }
  },
  created() {
    this.inputWidth = this.width
    if (!this.inline && this.width) {
      this.inputWidth = 200
    }
  },
  beforeDestroy() {
    this.checkAndUpdateBeforeDestroy()
  }
}
</script>

<style lang="scss" scoped>
.edit_item_inline {
  display: inline-block;
  margin-bottom: 20px;

  .my_title {
    width: 100%;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    margin-top: 5px;
    // margin-right: 5px;
  }
}

.edit_item_block {
  margin-bottom: 10px;

  .my_title {
    display: inline-block;
    margin-right: 10px;
  }
}

.input-wrapper {
  position: relative;
  display: inline-block;

  ::v-deep .el-input-number__increase,
  ::v-deep .el-input-number__decrease {
    visibility: hidden;
  }

  ::v-deep .el-input-number.is-controls-right .el-input__inner {
    padding-left: 10px;
    padding-right: 20px;
    &:focus {
      box-shadow: 0px 0px 0px 2px rgba(147,156,190,0.2);
    }
  }
  &:hover {
    .my-num-symbol {
      display: none;
    }
    ::v-deep .el-input-number__increase,
    ::v-deep .el-input-number__decrease {
      visibility: visible;
    }
  }
}

.number-ani-count {
  ::v-deep .el-input-number.is-controls-right .el-input__inner {
    padding-left: 12px;
    padding-right: 20px;
  }
}

.my-num-symbol {
  position: absolute;
  top: 0px;
  right: 1px;
  height: 28px;
  line-height: 28px;
  //background: #fff;
  z-index: 1;
  width: 25px;
  text-align: center;
  color: #999;
}
</style>
